import React, {useEffect, useRef, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import {findWalkInCustomers} from "../../utils/requestUtils";
import {formatPhoneNumber} from "../../core/telephone";

const apiUrl = Config.apiUrl;

function removeSpecialChars(str) {
    return (str || '').normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

function onlyDigits(str) {
    return (str || '').replace(/\D/g, '');
}

// Clientes de Take Away/Delivery (walkIn), os mesmos criados ao iniciar esses pedidos.
const WalkInCustomerList = () => {
    const [customers, setCustomers] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery() {
        try {
            setLoading(true);
            setCustomers((await findWalkInCustomers()) || []);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery();
    }, []);

    async function deleteCustomer(id) {
        try {
            setLoading(true);
            const url = apiUrl + '/api/customers/' + id;
            await makeRequest(url, 'DELETE', {'Useruuid': Cookies.get('userUUID')}, undefined, 5000, 1);
            await makeQuery();
        } catch (error) {
            console.error('Error deleting customer:', error);
            alert('Não foi possível excluir. Se o cliente já tem pedidos, desabilite-o no cadastro.');
        } finally {
            setLoading(false);
        }
    }

    const query = removeSpecialChars(queryString);
    const queryDigits = onlyDigits(queryString);
    const filteredCustomers = customers.filter((c) =>
        query === '' || removeSpecialChars(c.name).includes(query) || (queryDigits !== '' && onlyDigits(c.phone).includes(queryDigits))
    );

    return (
        <>
            <div className="header-label">Consulta de Clientes</div>

            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <input ref={inputQueryString} type="text" value={queryString} placeholder="Nome ou telefone"
                       onChange={(e) => setQueryString(e.target.value)}/>
                <button onClick={() => navigate('/walkin-customer')}>Novo</button>
            </div>

            <table style={{width: '100%'}}>
                <thead>
                <tr>
                    <th>Nome</th>
                    <th>Telefone</th>
                    <th/>
                    <th/>
                </tr>
                </thead>
                <tbody style={{overflowY: 'auto'}}>
                {filteredCustomers.map((customer) => (
                    <tr key={customer.id}>
                        <td>{customer.name}</td>
                        <td>{formatPhoneNumber(customer.phone || '')}</td>
                        <td>
                            <button onClick={() => navigate('/walkin-customer?id=' + customer.id)}>Editar</button>
                        </td>
                        <td>
                            <button className="remove-button" onClick={async () => {
                                if (window.confirm('Deseja realmente excluir?')) {
                                    await deleteCustomer(customer.id);
                                }
                            }}>Excluir
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
                {filteredCustomers.length === 0 && (
                    <tfoot>
                    <tr>
                        <td colSpan={4}>Nenhum item encontrado.</td>
                    </tr>
                    </tfoot>
                )}
            </table>
        </>
    );
};

export default WalkInCustomerList;
